var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 520",
    style: {
      enableBackground: "new 0 0 600 520"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#5AB361;}\r\n\t.st1{fill:#4FAF3E;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#4D9C34;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#865547;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#462B23;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#55312A;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#311916;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#312620;}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#191210;}\r\n\t.st9{fill:#55312A;}\r\n\t.st10{fill:#432D20;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_39_",
    x: 187.9,
    y: 2.1,
    className: "st0",
    width: 137,
    height: 135.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_38_",
    x: 463,
    y: 2.1,
    className: "st0",
    width: 137,
    height: 135.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_37_",
    x: 325.5,
    y: 2.1,
    className: "st0",
    width: 137,
    height: 135.4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_36_",
    x: 187.9,
    y: 2.1,
    className: "st1",
    width: 412.1,
    height: 135.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_35_",
    x: 187.9,
    y: 192.2,
    className: "st1",
    width: 412.1,
    height: 135.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_34_",
    x: 187.9,
    y: 382.3,
    className: "st1",
    width: 412.1,
    height: 135.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_75_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_33_",
    className: "st2",
    points: "59.4,383 118.7,417.3 59.4,451.5 0,417.3 59.4,383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_32_",
    className: "st3",
    points: "59.4,473.7 0,439.4 0,417.2 59.4,451.5 59.4,473.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_31_",
    className: "st4",
    points: "118.7,439.4 106,446.7 59.4,473.6 59.4,451.5 118.7,417.2 118.7,439.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_30_",
    className: "st5",
    points: "59.4,495.8 0,461.5 0,439.4 59.4,473.6 59.4,495.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_29_",
    className: "st6",
    points: "118.7,461.5 106,468.9 59.4,495.8 59.4,473.5 105.6,447 118.7,439.4 118.7,461.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_28_",
    className: "st7",
    points: "59.4,517.9 0,483.6 0,461.5 59.4,495.7 59.4,517.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_27_",
    className: "st8",
    points: "118.7,483.6 106,491 59.4,517.9 59.4,495.7 118.7,461.5 118.7,483.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_72_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_26_",
    className: "st9",
    points: "0,450.4 59.4,483.6 59.4,451.5 0,417.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_25_",
    className: "st10",
    points: "59.4,483.6 59.4,517.9 0,483.6 0,450.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_24_",
    className: "st9",
    points: "118.7,451.5 118.7,417.2 59.4,451.5 59.4,484.7  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_57_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_63_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_23_",
    className: "st2",
    points: "59.4,192.5 118.7,226.7 59.4,261 0,226.7 59.4,192.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_22_",
    className: "st3",
    points: "59.4,283.1 0,248.9 0,226.7 59.4,261 59.4,283.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_21_",
    className: "st4",
    points: "118.7,248.8 106,256.2 59.4,283.1 59.4,261 118.7,226.7 118.7,248.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_20_",
    className: "st5",
    points: "59.4,305.3 0,271 0,248.8 59.4,283.1 59.4,305.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_19_",
    className: "st6",
    points: "118.7,271 106,278.3 59.4,305.2 59.4,283 105.6,256.4 118.7,248.8 118.7,271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_18_",
    className: "st7",
    points: "59.4,327.4 0,293.1 0,270.9 59.4,305.2 59.4,327.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_17_",
    className: "st8",
    points: "118.7,293.1 106,300.5 59.4,327.4 59.4,305.2 118.7,270.9 118.7,293.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_60_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_16_",
    className: "st9",
    points: "0,259.9 59.4,293.1 59.4,261 0,226.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_15_",
    className: "st10",
    points: "59.4,293.1 59.4,327.4 0,293.1 0,259.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_14_",
    className: "st9",
    points: "118.7,261 118.7,226.7 59.4,261 59.4,294.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_13_",
    className: "st10",
    points: "59.4,293.1 118.7,261 118.7,293.1 59.4,327.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12_",
    className: "st2",
    points: "59.4,2.4 118.7,36.7 59.4,71 0,36.7 59.4,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    className: "st3",
    points: "59.4,93.1 0,58.8 0,36.7 59.4,71 59.4,93.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_10_",
    className: "st4",
    points: "118.7,58.8 106,66.2 59.4,93.1 59.4,70.9 118.7,36.7 118.7,58.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_9_",
    className: "st5",
    points: "59.4,115.2 0,80.9 0,58.8 59.4,93.1 59.4,115.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8_",
    className: "st6",
    points: "118.7,80.9 106,88.3 59.4,115.2 59.4,93 105.6,66.4 118.7,58.8 118.7,80.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7_",
    className: "st7",
    points: "59.4,137.3 0,103 0,80.9 59.4,115.2 59.4,137.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_6_",
    className: "st8",
    points: "118.7,103 106,110.4 59.4,137.3 59.4,115.2 118.7,80.9 118.7,103  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    className: "st9",
    points: "0,69.9 59.4,103 59.4,70.9 0,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4_",
    className: "st10",
    points: "59.4,103 59.4,137.3 0,103 0,69.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3_",
    className: "st9",
    points: "118.7,71 118.7,36.7 59.4,71 59.4,104.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_40_",
    className: "st10",
    points: "59.4,103 118.7,71 118.7,103.1 59.4,137.3  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st10",
    points: "59.4,483.6 118.7,451.5 118.7,483.6 59.4,517.9  "
  }))));
};

export default SvgLogo;